import * as React from "react";
import {MouseEvent} from "react";
import {connect} from "react-redux";
import UserRedirectComponent from "./UserRedirectComponent";
import {push} from "react-router-redux";
import {ConversationsRoutes, ShopsRoutes, SpecialsRoutes, StylesRoutes, UsersRoutes} from "../../routes";
import {ResourceType} from "../../_helpers/data";

interface Props {
    id: number;
    className?: string;
    type?: string;
    element: string;
}

const mapStateToProps = (state, props: Props) => {

    return {
        id: props.id,
        className: props.className,
        element: props.element,
        type: props.type
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        click: (id: number, e: MouseEvent<HTMLElement>, type: string) => {
            e.stopPropagation();
            if (type == ResourceType.user)
                dispatch(push(UsersRoutes.show(id), {state: {refresh: true}}));
            else if (type == ResourceType.shop)
                dispatch(push(ShopsRoutes.view(id), {state: {refresh: true}}));
            else if (type == ResourceType.style)
                dispatch(push(StylesRoutes.show(id), {state: {refresh: true}}));
            else if (type == ResourceType.special)
                dispatch(push(SpecialsRoutes.show(id), {state: {refresh: true}}));
            else if (type == ResourceType.message)
                dispatch(push(ConversationsRoutes.new(id), {state: {refresh: true}}))
        }
    }
};

const UserRedirectContainer = connect(mapStateToProps, mapDispatchToProps)(UserRedirectComponent);
export default UserRedirectContainer;


// WEBPACK FOOTER //
// ./app/client/_widgets/user/UserRedirectContainer.tsx